import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const state = {
    logs: []
}

export default {
    state,
    getters,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/logger/index.js